import { Button, DatePicker } from 'components/form'
import CustomModal from 'components/modals/CustomModal';
import React, { useState } from 'react'
import { formatAllDate } from 'utils/commonFun';

const DateFilter = ({ show, close, customDate, setCustomDate = () => { }, localCustomDate, setLocalCustomDate = () => { } }) => {

    // ----------handle-date-button---------------
    const handleDateChange = (name, date) => {
        setLocalCustomDate((prev) => ({
            ...prev, [name]: formatAllDate(date),
        }));
    };
    const submit = () => {
        setCustomDate(localCustomDate)
        // handleCloseModal()
    }
    // IMS gaziabadh 
    const handleCloseModal = () => {
        close()
        // setLocalCustomDate({ from: '', to: '' })
    }
    return (
        // <CustomModal
        //     show={show}
        //     handleClose={close}
        // // className={"logoutModal"}
        // // closeButton={false}
        // >
        <div className="download_statement transaction_details">
            <div className="form_field">
                {/* <label className="label">Search by Date Range</label> */}
                <div className="date_wrap">
                    <div className="date">
                        {" "}
                        <DatePicker
                            placeholder="from date"
                            onChange={(date) => handleDateChange("from", date)}
                            value={localCustomDate?.from}
                            maxDate={localCustomDate?.to ? new Date(localCustomDate.to) : new Date()} // Limit to today or endDate
                        />
                    </div>
                    <div className="date">
                        <DatePicker
                            placeholder="to date"
                            onChange={(date) => handleDateChange("to", date)}
                            value={localCustomDate?.to}
                            minDate={localCustomDate?.from ? new Date(localCustomDate.from) : null}
                            maxDate={new Date()}
                        />
                    </div>
                    <Button onClick={submit}>Apply</Button>
                </div>
            </div>
        </div>
        // </CustomModal>
    )
}

export default DateFilter